import React from 'react';
const idealFor = [{
  emoji: '👩‍🏫',
  label: 'Docentes de primaria'
}, {
  emoji: '🧑‍🏫',
  label: 'Maestras de grado'
}, {
  emoji: '📚',
  label: 'Equipos de orientación'
}, {
  emoji: '🧠',
  label: 'Psicopedagogas'
}, {
  emoji: '🤝',
  label: 'Acompañantes terapéuticos'
}, {
  emoji: '🏠',
  label: 'Familias que trabajan contenidos escolares'
}];
export function BeforeAfterSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-24">
      <div className="max-w-5xl mx-auto" data-id="element-25">
        <h2 className="text-[20px] font-black mb-2 text-center text-[#EF5B4C]" data-id="element-26">
          IDEAL PARA:
        </h2>

        <p className="text-center text-gray-600 mb-6 text-base md:text-lg max-w-2xl mx-auto" data-id="element-27">
          Un material pensado para quienes acompañan el aprendizaje desde
          distintos lugares.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-28">
          {idealFor.map((item, index) => <div key={index} className="bg-white rounded-2xl p-5 shadow-md border border-gray-100 flex flex-col items-center text-center hover:shadow-lg hover:border-[#EF5B4C] transition-all" data-id="element-29">
              <span className="text-5xl mb-3" data-id="element-30">{item.emoji}</span>
              <p className="text-base md:text-lg font-bold text-gray-800" data-id="element-31">
                {item.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}